/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Format_LabelInputs */

const en_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Format`)
};

const fr_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format de sous-titres`)
};

const de_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformat`)
};

const it_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato dei sottotitoli`)
};

const ru_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат субтитров`)
};

const es_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de subtítulos`)
};

const zh_cn2_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕格式`)
};

const ja_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕フォーマット`)
};

const hi_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक प्रारूप`)
};

const pt_pt2_iconik_publish_format_label = /** @type {(inputs: Iconik_Publish_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle Format" |
*
* @param {Iconik_Publish_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_format_label = /** @type {((inputs?: Iconik_Publish_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_format_label(inputs)
	if (locale === "de") return de_iconik_publish_format_label(inputs)
	if (locale === "it") return it_iconik_publish_format_label(inputs)
	if (locale === "ru") return ru_iconik_publish_format_label(inputs)
	if (locale === "es") return es_iconik_publish_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_format_label(inputs)
	if (locale === "ja") return ja_iconik_publish_format_label(inputs)
	if (locale === "hi") return hi_iconik_publish_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_format_label(inputs)
	return en_iconik_publish_format_label(inputs)
});